import { render, staticRenderFns } from "./PedidosTabelaLog.vue?vue&type=template&id=6fea03d1&"
import script from "./PedidosTabelaLog.vue?vue&type=script&lang=ts&"
export * from "./PedidosTabelaLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
